import React, { type ReactNode } from "react";

interface StatItemProps {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function StatItem({
  label,
  children,
  className,
}: StatItemProps): React.ReactElement {
  return (
    <div className={className ?? "grid grid-flow-row"}>
      <p className="app-text-sub2 md:app-text-body1 text-muted-light text-center">
        {label}
      </p>
      <div className="flex items-center justify-center h-12 md:h-16">
        {children}
      </div>
    </div>
  );
}
